<template>
  <div v-if="localShow"
       v-bind:class="[
            type === 'success' ? success : danger
        ]" role="alert">
    <span class="block sm:inline"><slot></slot></span>
    <span @click="closeAlert"
          class="absolute top-0 bottom-0 right-0 px-4 py-3 cursor-pointer">
      <svg class="fill-current h-6 w-6" role="button" xmlns="http://www.w3.org/2000/svg"
           :class="[ type === 'success' ? 'text-green-500' : 'text-red-500' ]"
           viewBox="0 0 20 20">
        <title>Fechar</title>
        <path d="M14.348 5.652a1 1 0 0 0-1.414 0L10 8.586 7.066 5.652a1 1 0 1 0-1.414 1.414L8.586 10l-2.934 2.934a1 1 0 1 0 1.414 1.414L10 11.414l2.934 2.934a1 1 0 0 0 1.414-1.414L11.414 10l2.934-2.934a1 1 0 0 0 0-1.414z"/>
      </svg>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    show: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'success'
    }
  },
  data() {
    return {
      localShow: this.show,
      success: "mb-2 bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative",
      danger: "mb-2 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
    }
  },
  watch: {
    show(val) {
      this.localShow = val;
    }
  },
  methods: {
    closeAlert() {
      this.localShow = false;
      this.$emit('close');
    }
  }
}
</script>

